/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');
var Syphon = require('backbone.syphon');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');

var SubmitIndividualFlaggedStatus = require('../services/SubmitIndividualFlaggedStatus');

require('../styles/NonDepIndividualEditFlaggedView.css');
var tmplNonDepIndividualEditFlaggedView = require('../templates/NonDepIndividualEditFlaggedView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepIndividualEditFlaggedView,

  className: 'non-dep-individual-edit-flagged-view container-fluid m-b-lg',

  ui: {
    breadcrumb: '.breadcrumb-container',
    flaggedForm: '.flagged-form',
    flaggedNotesContainer: '.flagged-notes-container',
    submit: '.btn-submit'
  },

  regions: {
    flaggedNotesContainer: '@ui.flaggedNotesContainer',
    breadcrumb: '@ui.breadcrumb'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var individual = this.model.get('individual'),
      individualType = individual.individualType,
      entityId = this.model.get('entityId'),
      entityName = this.model.get('entityName'),
      licenseId = this.model.get('licenseId'),
      licenseNumber = this.model.get('licenseNumber'),
      licenseType = this.model.get('licenseType'),
      breadcrumbs;

    if (individualType === 'Entity Officer') {
      breadcrumbs = [
        {
          link: '#nondep/dashboard',
          text: 'Home'
        },
        {
          text: entityName,
          link: '#nondep/entity/' + entityId + '/dashboard'
        },
        {
          text: individual.lastName
            ? individualType + ' - ' + individual.firstName + ' ' + individual.lastName
            : individualType + ' - ' + individual.firstName,
          link: '#nondep/individual/' + this.model.get('individualId') + '/dashboard'
        },
        {
          text: 'Edit Flagged Status'
        }
      ];
    } else if (individualType === 'Office Manager') {
      breadcrumbs = [
        {
          link: '#nondep/dashboard',
          text: 'Home'
        },
        {
          text: entityName,
          link: '#nondep/entity/' + entityId + '/dashboard'
        },
        {
          text: 'License #' + licenseNumber + ' - ' + licenseType,
          link: '#nondep/entity/' + entityId + '/license/' + licenseId
        },
        {
          text: individualType + ' - ' + individual.firstName + ' ' + individual.lastName,
          link: '#nondep/individual/' + this.model.get('individualId') + '/dashboard'
        },
        {
          text: 'Edit Flagged Status'
        }
      ];
    } else {
      breadcrumbs = [
        {
          link: '#nondep/dashboard',
          text: 'Home'
        },
        {
          text: individualType + ' - ' + individual.firstName + ' ' + individual.lastName,
          link: '#nondep/individual/' + this.model.get('individualId') + '/dashboard'
        },
        {
          text: 'Edit Flagged Status'
        }
      ];
    }

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: breadcrumbs
      })
    );
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var individualType = this.model.get('individual').individualType;
    var individualId = this.model.get('individualId');

    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        var formData = Syphon.serialize(this);
        formData.individualId = individualId;
        formData.flaggedStatus = formData.placeFlagged ? '1' : '0';

        SubmitIndividualFlaggedStatus(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:individual-dashboard', individualId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.flaggedForm.parsley().whenValidate();
  }
});
